import { orderBy } from 'lodash';
import api from '../../global/api';
import {
  FiscalYearDates,
  MunicipalitiesApiResponse,
} from './buy-process-form-types';

export const fetchMunicipalities = async () => {
  const response = await api.get<MunicipalitiesApiResponse>('/municipalities');
  return orderBy(response.data, 'value', 'asc');
};

export const fetchClosingDatesOptions = async () => {
  const response = await api.get<FiscalYearDates>('/first-closing-dates');
  return response.data;
};
